import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import { FormWrapper } from '@Root/HOCs'
import { Field } from '@Root/components'
import { fieldTooltipManagerSelectors } from '@Root/store'
import { useError, useToggle } from '@Root/hooks'
import { useSelector } from 'react-redux'
import { validateData } from '@Root/helpers'

const titles = { onRead: 'Session Status', onEdit: 'Edit Session Status', onCreate: 'Create Session Status' }
export const SessionStatusForm = ({
  canEdit,
  canDelete,
  onDelete,
  onSave,
  onCancel,
  isNew,
  initialValue,
  isLoading,
  isSuccess,
  options,
  onOpenDescriptionModal,
}) => {
  const [data, setData] = useState({})
  const [isEditable, toggleEditable] = useToggle(Boolean(isNew))
  const { errors, setError, onClear: onClearError } = useError()
  const descriptions = useSelector(fieldTooltipManagerSelectors.contactDescriptions).person.hesa_details.student_course_sessions

  useEffect(() => {
    if (initialValue) setData(initialValue)
  }, [initialValue])

  useEffect(() => {
    if (isSuccess) {
      toggleEditable()
      onClearError()
    }
  }, [isSuccess])

  const onChangeValue = field => value => {
    setData(prevState => ({ ...prevState, [field]: value }))
  }

  const validateForm = () => {
    const { status_valid_from, status_change_id } = data
    if (!status_valid_from) {
      setError('status_valid_from', 'Required')
      return false
    }
    if (!status_change_id) {
      setError('status_change_id', 'Required')
      return false
    }
    if (validateData([status_valid_from])) {
      return false
    }
    return true
  }

  const onCancelEditMode = () => {
    onChangeMode()
    setData(initialValue)
  }

  const onChangeMode = () => {
    toggleEditable()
  }

  const onSubmitForm = () => {
    if (!validateForm()) return
    onSave(data)
  }

  const onCancelEdit = () => {
    if (!isNew) {
      onCancelEditMode()
      onClearError()
      return
    }
    onCancel()
  }

  const { onEdit, onRead, onCreate } = titles
  return (
    <div className={styles.form}>
      <FormWrapper
        buttons={isEditable ? ['cancel', ...(canDelete ? ['delete'] : []), 'save'] : []}
        buttonsNames={[{ button: 'delete', name: 'Delete this Session Status' }]}
        buttonsAreDisabled={isLoading}
        isSpinning={isLoading}
        clickCancelButtonHandler={onCancelEdit}
        clickDeleteButtonHandler={onDelete}
        clickSaveButtonHandler={onSubmitForm}
        editTitle={onEdit}
        readTitle={onRead}
        createTitle={onCreate}
        clickToggleEditModeButtonHandler={onChangeMode}
        isEditable={isEditable}
        canEdit={canEdit}
        isCreate={isNew}
        idForm={data?.id ? `session_status_${data?.id}` : null}
        isSuccess={isSuccess}
      >
        <div className={styles.grid}>
          <div className={styles.column}>
            <div className={styles.row}>
              <Field
                label={'Status valid from'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={data.status_valid_from}
                onChange={onChangeValue('status_valid_from')}
                placeholder='Status valid from'
                isDisabled={!isEditable}
                description={descriptions?.status_valid_from}
                onOpenDescriptionModal={onOpenDescriptionModal}
                field={'datePicker'}
                isRequired={isEditable}
                error={errors.status_valid_from}
              />
              <Field
                label={'Status changed to'}
                classNames={!isEditable ? ['borderless'] : []}
                style={{ width: 260 }}
                value={data.status_change_id}
                onChange={onChangeValue('status_change_id')}
                placeholder='Status changed to'
                isDisabled={!isEditable}
                options={options.status_changed_to}
                description={descriptions?.status_change_id}
                onOpenDescriptionModal={onOpenDescriptionModal}
                field={'select'}
                isRequired={isEditable}
                error={errors.status_change_id}
              />
            </div>
          </div>
        </div>
      </FormWrapper>
    </div>
  )
}
